import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import CampoNit from "../custom/CampoNit";


function NuevaEmpresa() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [nombre, setNombre] = useState('');
    const [nit, setNit] = useState('');
    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            client_id: client.client_id,
            nombre_empresa: nombre,
            nit: nit
        };

        axios.post('/empresa', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('nueva_empresa', JSON.stringify({ nombre: nombre, id: response.data.resultado }));
                    //localStorage.setItem('toastmsg','La empresa '+nombre+' ha sido creada');
                    history.push('/empresas');
                }
            )
            .catch(
                err => {
                    console.log(JSON.stringify(err));
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    function handleNit(nit, dv) {
        setNit(nit);
    }


    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-convenios">Administrar Empresas y Convenios</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/empresas">Empresas</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Empresa</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nueva Empresa</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-10">

                                    <div className="card">
                                        <div id="infobasica">
                                            <div className="card-body">

                                                <form id="role-form" onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="nombre">Nombre</label>
                                                                <input type="text" name="nombre" className="form-control" id="nombre" onChange={(e) => setNombre(e.target.value)} autoFocus />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.nombre_empresa}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                {/*<input type="text" name="nit" className="form-control" id="nit" onChange={(e) => setNit(e.target.value)} />*/}
                                                                <CampoNit onChange={handleNit} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.nit}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-4">
                                                        <div className="col-md-12 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mr-3 d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                onClick={() => history.push('/empresas')}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-times mr-2"></i> Cancelar
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                disabled={loading}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-save mr-2"></i> Crear Empresa
                                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default NuevaEmpresa;